// user.reducer, user.action 以外のファイルからも直接利用されている
export const FETCH_USER_INFO = 'FETCH_USER_INFO';
export const UPDATE_USER_CAREER_MOTIVATION = 'UPDATE_USER_CAREER_MOTIVATION';

// user.action で定義された関数が、各所で利用されている
export const TOGGLE_PERSONALITY_ANSWER = 'TOGGLE_PERSONALITY_ANSWER';
export const TOGGLE_DESIRED_CONDITIONS_ANSWER =
  'TOGGLE_DESIRED_CONDITIONS_ANSWER';

// 通知の未読数
export const UPDATE_UNREAD_COUNT = 'UPDATE_UNREAD_COUNT';
export const REDUCE_UNREAD_COUNT = 'REDUCE_UNREAD_COUNT';

// メッセージの未読数 カウントはcontext(=部屋)単位
export const REDUCE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT =
  'REDUCE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT';
export const UPDATE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT =
  'UPDATE_UNREAD_ALL_MESSAGE_CONTEXT_COUNT';
